import { useState, useRef } from 'react';
import ReactMarkdown from 'react-markdown';
import { ArrowDownIcon } from '@phosphor-icons/react';
import { Button } from '../Utility/Button';
import { RootState, useAppSelector } from '../../store';
import { settingsService } from '../../Services/settingsService';

function DSGVO() {
    const [isFocused, setIsFocused] = useState(false);
    const contentRef = useRef<HTMLDivElement>(null);
    const i18n = useAppSelector((state: RootState) => state.i18n.i18n);
    const settings = useAppSelector((state: RootState) => state.settings);
    const userSettings = useAppSelector((state: RootState) => state.userSettings);
    const demo = useAppSelector((state: RootState) => state.settings.demo);
    const themes = useAppSelector((state: RootState) => (state as any).themes?.allThemes || {});
    const selectedTheme = useAppSelector((state: RootState) => (state as any).themes?.selectedTheme || '');
    const themeLogo = themes[selectedTheme].logo;

    const accept = async () => {
        try {
            await settingsService.acceptDsgvo();
            document.location.reload();
        } catch (error) {
            console.error('Error accepting DSGVO:', error);
        }
    };

    const shouldShowDSGVO =
        settings.dataProtectionText &&
        settings.dsgvoVersionTimestamp > 0 &&
        (userSettings.dsgvoAcceptedAt === 0 || userSettings.dsgvoAcceptedAt < settings.dsgvoVersionTimestamp);

    return shouldShowDSGVO ? (
        <>
            <div className="fixed inset-0 flex items-center justify-center z-[15]">
                <div
                    className={`${
                        demo ? 'demo-dashed-border' : ''
                    } p-8 bg-dsgvo-backgroundColor shadow-xl rounded-xl relative max-w-[850px] w-full`}
                >
                    {themeLogo && (
                        <div className="text-center mb-8">
                            <img src={themeLogo} alt="Logo" className="mx-auto h-8 w-auto" />
                        </div>
                    )}
                    <h5 className="m-0 mx-0 p-0 text-layout-textcolor text-center">
                        {i18n.translate({
                            id: 'welcome',
                            sourceName: 'DSGVO',
                        })}
                    </h5>
                    {demo && (
                        <h3 className="m-0 mx-0 p-0 text-primary text-center">
                            {i18n.translate({
                                id: 'demo',
                                sourceName: 'DSGVO',
                            })}
                        </h3>
                    )}
                    <div className="relative my-8">
                        <div
                            ref={contentRef}
                            tabIndex={0}
                            className={`bg-dsgvo-boxBackgroundColor rounded-xl p-3 border-2 border-input-borderColor outline-none focus:border-primary transition-all duration-100 ${
                                !isFocused ? 'overflow-hidden' : 'overflow-auto'
                            }`}
                            style={{
                                maxHeight: isFocused ? '50vh' : '12vh',
                            }}
                            onFocus={() => setIsFocused(true)}
                            onBlur={(e) => {
                                setIsFocused(false);
                                e.currentTarget.scrollTop = 0;
                            }}
                        >
                            <ReactMarkdown className="my-3 mx-5 text-layout-textcolor">
                                {settings.dataProtectionText}
                            </ReactMarkdown>
                        </div>
                        {!isFocused && (
                            <div className="absolute w-fit h-fit bottom-[-15px] right-0 left-0 m-auto">
                                <button
                                    type="button"
                                    onClick={() => contentRef.current?.focus()}
                                    className="rounded-full h-[25px] md:h-[35px] w-[25px] md:w-[35px] transition-all duration-100 text-chatInput-sendButtonColor bg-chatInput-sendButtonBackground hover:bg-chatInput-sendButtonBackground-hover border-none flex items-center justify-center"
                                >
                                    <ArrowDownIcon />
                                </button>
                            </div>
                        )}
                    </div>
                    <div className="flex justify-end items-center mx-0">
                        <Button onClick={accept}>{i18n.translate({ id: 'accept', sourceName: 'DSGVO' })}</Button>

                        {demo && (
                            <div className="space-x-2 hidden md:flex">
                                <Button onClick={() => (document.location.href = 'https://www.varios-ai.com')}>
                                    {i18n.translate({
                                        id: 'website',
                                        sourceName: 'DSGVO',
                                    })}
                                </Button>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <img
                className="w-full h-full object-cover z-0 fixed left-0 top-0"
                src="/img/background_varios.jpg"
                alt=""
            />
        </>
    ) : (
        <div></div>
    );
}

export default DSGVO;
